import { FC, useId } from 'react';
import { Trans } from 'react-i18next';
import { Check } from '@agendapro/emerald-icons';
import { useTheme } from 'styled-components';

import { resolveBookingPrivacyPolicy } from '@/utils/privacyPolicy';
import * as St from './BookingConsent.styles';
import { BookingConsentProps } from './BookingConsent.types';

export const BookingConsent: FC<BookingConsentProps> = ({
  checked,
  onChange,
  policyTermActive,
  policyTerm,
  companyName,
  countryCode,
  id,
  name,
  className,
}) => {
  const { palette } = useTheme();
  const generatedId = useId();
  const inputId = id || generatedId;
  const { url, owner } = resolveBookingPrivacyPolicy({ policyTermActive, policyTerm, companyName, countryCode });

  return (
    <St.Container className={className} data-testid="booking-consent">
      <St.CheckboxBox>
        <St.Input
          id={inputId}
          name={name}
          type="checkbox"
          checked={checked}
          onChange={(event) => onChange(event.target.checked)}
          aria-required
          data-testid="booking-consent-checkbox"
        />
        {checked && <Check size={16} color={palette.white} className="check" />}
      </St.CheckboxBox>
      {/* A link inside a label does not toggle the control, so only the rest of the text checks the box. */}
      <St.Label htmlFor={inputId}>
        <Trans
          i18nKey="BOOKING_CONSENT.TEXT"
          values={{ owner }}
          // The company name is free text: escape it before Trans parses the string as markup.
          tOptions={{ interpolation: { escapeValue: true } }}
          shouldUnescape
          components={{
            policy: (
              <St.PolicyLink
                href={url}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="booking-consent-policy-link"
              />
            ),
          }}
        />
      </St.Label>
    </St.Container>
  );
};
